const request = require('../../http');
const config = require('../../config');
const UserPreferences = require('../UserPreferences');
const find = require('array-find');

export class BaseCollection {
    constructor() {
        this.MINIMUM_TO_DISPLAY = 8;

        const pref = UserPreferences.get();
        this.topics = pref.subscriptions.filter(item => item.enabled);
        this.topicKeys = this.topics.map(item => item.topic);
    }

    dedupeData(data) {
        const ids = [];
        const uniques = [];

        data.forEach((i) => {
            if (ids.indexOf(i.id) >= 0) {
                return;
            }

            uniques.push(i);
            ids.push(i.id);
        });

        return uniques;
    }

    filterData(data) {
        const pref = UserPreferences.get();
        const productsEnabled = pref.preferences.productsEnabled
            .filter(p => p.enabled)
            .map(p => p.product);

        this.topics = pref.subscriptions.filter(item => item.enabled);
        this.topicKeys = this.topics.map(item => item.topic);

        return data.filter((item) =>
            // Check we have enabled the notification product,
            // and we are subscribed to at least one topic in a notification
            productsEnabled.includes(item.product) && item.topic.some((notificationTopic) => {
                if (this.topicKeys && this.topicKeys.includes(notificationTopic)) {
                    const topicSubscription =
                        find(this.topics, (topic) =>
                            topic.topic === notificationTopic);

                    // Check we subscribed to the topic before this notification was sent
                    if (topicSubscription &&
                        new Date(item.creationTimestamp)
                        > new Date(topicSubscription.lastSubscribed)) {
                        return true;
                    }
                }

                return false;
            }
        ));
    }

    loadData(folder, page = 'latest.json') {
        const url = `https:${config.env.feedBaseUrl}${folder}/${page}`;
        const now = new Date();

        return request(url, null, (page !== 'latest.json'))
            .catch((err) => {
                throw err;
            })
            .then((data) => {
                const list = [];
                if (!data) {
                    return { list, next: null, reachedEnd: true };
                }

                console.log('Base collection filtering data', data);

                let reachedEnd = false;
                if (data.notifications) {
                    data.notifications.forEach((notif) => {
                        const notifDate = new Date(notif.creationTimestamp);

                        const timeDiff = Math.abs(now.getTime() - notifDate.getTime());
                        const daysOld = Math.ceil(timeDiff / (1000 * 3600 * 24));

                        if (daysOld >= config.env.maxNotificationAge) {
                            reachedEnd = true;

                            if (daysOld > config.env.maxNotificationAge) {
                                return;
                            }
                        }

                        list.push(notif);
                    });
                }

                const next = data.next && data.next !== 'false' ? data.next : null;

                return { list, next, reachedEnd };
            });
    }
}



/** WEBPACK FOOTER **
 ** ./assets/js/models/collections/BaseCollection.js
 **/